(function () {
  // Event delegation — catches forms added dynamically via AJAX cart reloads
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-upsell-form]');
    if (!form) return;

    e.preventDefault();

    var button = form.querySelector('.cart-upsell-block__button');
    if (!button || button.disabled) return;

    button.classList.add('is-loading');
    button.disabled = true;

    var variantId = form.querySelector('[name="id"]').value;

    fetch(window.theme.routes.root_url + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw res;
        return res.json();
      })
      .then(function () {
        var block = form.closest('.cart-upsell-block');
        if (block) block.classList.add('is-hidden');

        return fetch(window.theme.routes.root_url + 'cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart: cart },
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      })
      .catch(function (err) {
        button.classList.remove('is-loading');
        button.disabled = false;

        if (err && typeof err.json === 'function') {
          err.json().then(function (data) {
            console.error('Upsell add error:', data.description || data.message);
          });
        } else {
          console.error('Upsell add error:', err);
        }
      });
  });
})();
